module.exports = __webpack_public_path__ + "img/930a91f84735010f57ee828b6c44f94a.jpg";